<div [ngClass]="{ 'items-center': number() == null && !loading() }" class="flex w-full h-full 2xl:gap-[18px] gap-3.5">
    <div [ngStyle]="{ 'background-color': iconBgColor(), 'color': iconColor() }"  class="bg-[#E4E4FF] 2xl:w-[48px] 2xl:h-[48px] w-11 h-11 flex justify-center items-center rounded-[1.1rem]">
        <i [ngClass]="iconClass()" class="2xl:text-xl text-base"></i>
    </div>
    <div class="flex-1">
        <p class="text-[#4B4B4B] 2xl:text-sm text-xs">{{ title() }}</p>

        <div *ngIf="loading()" class="w-full flex items-center mt-2.5 h-4 2xl:h-5">
            <div class="h-4 w-14 bg-gray-200 rounded-md animate-pulse"></div>
        </div>

        <div *ngIf="!loading()" class="w-full flex gap-1 mt-2.5 font-semibold 2xl:text-sm text-xs">
            <p>{{ number() }}</p>
            <p *ngIf="showCurrency()">{{ 'common.currency' | translate }}</p>
        </div>

        <div *ngIf="description()" class="w-full flex flex-row gap-1 mt-2.5 text-xs">
          <p>{{ description() }}</p>
          <div [ngClass]="subDescriptionColor()">
            <p>{{ subDescription() }}</p>
          </div>
        </div>
    </div>
</div>
